export default "__VITE_ASSET__77839398__"